import Vue from 'vue'
import configs from '@/config'

let resource = null
const presentationPath = `${configs.baseUrl}/api/presentation`

const actions = {
  unlink: {
    method: 'PATCH',
    url: `${presentationPath}/unlink-from-trash`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const unlink = async (params) => {
    const res = await resource.unlink(params)
    return res.body
}

const unlinkPresentation = async ({ presentationIds, email, userId, options }) => {
    const params = {
        presentationIds,
        email,
        userId,
        ...options
    }
    const res = await resource.unlink(params)
    return res.body
}

export default {
  initResource,
  unlink,
  unlinkPresentation,
}